













































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore";

@Component({
  name: "multipleChoice",
})
export default class MultipleChoice extends Vue {
  private newArr: Array<string> = [];
  private zItem!: any;
  @Prop({ type: Number, default: {} }) zIndex!: number;
  @Prop({ type: Boolean, default: true }) showScore!: boolean;
  @Prop({ type: String, default: "" }) businessType!: string;
  @Prop({ type: Boolean, default: true }) Required!: boolean;
  @Watch("zIndex", { immediate: true })
  // eslint-disable-next-line
  watchIndex() {}
  @Prop({ type: Object, default: {} })
  item!: any;
  @Watch("item", { immediate: true, deep: true })
  dataChage(value: any) {
    this.zItem = value;
  }

  get questionnaireType() {
    return this.businessType || QuestionnaireEditModule.questionnaireType;
  }
}
